var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config.enabled)?_c('el-select',{attrs:{"options":_vm.icons},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_c('p',[_vm._v("Icons is not enabled on this CMS. Please contact the site administrator so a developer can enable this feature.")])
}
var staticRenderFns = []

export { render, staticRenderFns }